import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaFileExcel } from 'react-icons/fa';
import GenereCsv from './GenereCsv';

const Relance = ({ gotoAuth }) => {

    const url = localStorage.getItem('url');
    const code = localStorage.getItem('code');
    const [visible, setVisible] = useState(false);
    const [data, setData] = useState([]);

    const getData = () => {
        console.log('code', code);
        if (code === '') {
            gotoAuth();
            return;
        }

        if (window.confirm(`La création de ce lien rendra les liens précédemmeent envoyés inactifs.\r\nVoulez-vous créer un nouveau lien d'adhésion ?`)) {

            // Appel de l'API
            fetch(`${url}Relance/${code}`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.data)
                        gotoAuth();
                    else {
                        setVisible(true)
                        setData(data.data);
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }

    return (
        <>
            <Button variant="outline-primary" onClick={getData}><FaFileExcel />&nbsp;Relance</Button>
            {visible !== false && <GenereCsv data={data} fichier="publipostage" visible={true} />}
        </>
    );
}

export default Relance;
